import { render } from "./SpmTableApiControlsPanel.vue?vue&type=template&id=fcbd3b9c"
import script from "./SpmTableApiControlsPanel.vue?vue&type=script&lang=ts"
export * from "./SpmTableApiControlsPanel.vue?vue&type=script&lang=ts"

import "./SpmTableApiControlsPanel.vue?vue&type=style&index=0&id=fcbd3b9c&lang=scss"
script.render = render

export default script